import { Button, SxProps, Theme } from '@mui/material'
import React, { useState } from 'react'
import {
    IframeTitle,
    LoadingSpinner,
    PageSettings,
    Prefill,
    Utm,
} from '../../calendly'
import '../../calendly-widget.css'
import Modal from '../PopupModal/Modal'

export interface Props {
    url: string
    text: string
    rootElement: HTMLElement
    prefill?: Prefill
    utm?: Utm
    pageSettings?: PageSettings
    styles?: SxProps<Theme>
    className?: string
    iframeTitle?: IframeTitle
    LoadingSpinner?: LoadingSpinner
}

const PopupButton = (props: Props) => {
    const [isOpen, setIsOpen] = useState(false)

    const onClick = (e: React.SyntheticEvent) => {
        e.preventDefault()
        setIsOpen(true)
    }

    const onClose = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        window.location.reload()
        // reload page?
        setIsOpen(false)
    }
    return (
        <>
            <Button
                onClick={onClick}
                sx={props.styles || {}}
                className={props.className || ''}
            >
                {props.text}
            </Button>
            <Modal
                {...props}
                open={isOpen}
                onModalClose={onClose}
                rootElement={props.rootElement}
            />
        </>
    )
}

export default PopupButton
